module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-up--.4573ed3a.svg";